import React, { useState, useEffect } from 'react';
import '../../components/JoinUs/JoinUs.css';
import Join from '../../assets/images/JoinUs.png';
import Stats from '../../assets/images/StatsImg.png';
import BuyerImage from '../../assets/images/buyer.png';
import SellerImage from '../../assets/images/seller.png';
import '../../styles/CustomClassCss/Custom.css';
import { MdArrowOutward } from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";

const JoinUs = () => {
  const [activeLink, setActiveLink] = useState("joinUs");

  const [buyers, setBuyers] = useState(0);
  const [sellers, setSellers] = useState(0);
  const [enquiries, setEnquiries] = useState(0);
  const [quotations, setQuotations] = useState(0);

  const sectionVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.2, ease: "easeInOut" }
    },
  };

  const contentVariant = {
    hidden: { opacity: 0, x: -10 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5, ease: "easeInOut" }
    },
    exit: {
      opacity: 0,
      x: 50,
      transition: { duration: 0.5, ease: "easeInOut" }
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (buyers < 1475) setBuyers(prev => prev + 1);
      if (sellers < 2000) setSellers(prev => prev + 1);
      if (enquiries < 60) setEnquiries(prev => prev + 1);
      if (quotations < 40) setQuotations(prev => prev + 1);
    }, 10);

    return () => clearInterval(interval);
  }, [buyers, sellers, enquiries, quotations]);

  const handleLinkClick = (e, link) => {
    e.preventDefault();
    setActiveLink(link);
  };

  const getImage = () => {
    switch (activeLink) {
      case "buyers":
        return BuyerImage;
      case "sellers":
        return SellerImage;
      default:
        return Join;
    }
  };

  const getContent = () => {
    switch (activeLink) {
      case "joinUs":
        return {
          title: "Join Us",
          description: (
            <>
              <p className="font-poppins">
              Stelmart connects buyers, sellers, and financial institutions to simplify transactions, ensure secure payments, and provide financial support. Whether expanding your business or securing the best deals, Stelmart makes trade seamless and efficient. 
              </p>
            </>
          )
        };
      case "buyers":
        return {
          title: "For Buyers",
          description: (
            <p className="font-poppins">
             We help you find and purchase the products you need. From a diverse range of options to easy price comparisons, Stelmart helps you select the perfect materials for any project, big or small. Say goodbye to confusion and delays, and enjoy a fast, reliable shopping experience.
            </p>
          )
        };
      case "sellers":
        return {
          title: "For Sellers",
          description: (
            <p className="font-poppins">
              As a seller, Stelmart gives you access to a broad customer base looking for top-quality steel and polymer products. With user-friendly tools to manage listings, monitor sales, and communicate with buyers, you’ll have everything you need to expand your business. Stelmart makes it easier for you to focus on growing your sales while we handle the details.
            </p>
          )
        };
      default:
        return {
          title: "",
          description: ""
        };
    }
  };

  return (
    <div>
      <div className="container">
        <motion.div
          className="main-grid custom-inner-space custom-container-upper"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <motion.div
            className="left-section"
            variants={sectionVariant}
          >
            <div className="about-top font-poppins">WHY CHOOSE STELMART?</div>
            <p className="font-poppins">
              <strong>Stelmart:</strong> The Smart Way to Buy and Sell Steel and Polymer Products
            </p>
            <a
              href="#"
              className={`join-us-link font-merriweather ${activeLink === "joinUs" ? "active" : ""}`}
              onClick={(e) => handleLinkClick(e, "joinUs")}
            >
              JOIN US {activeLink === "joinUs" && <MdArrowOutward />}
            </a>
            <a
              href="#"
              className={`join-us-link font-merriweather ${activeLink === "buyers" ? "active" : ""}`}
              onClick={(e) => handleLinkClick(e, "buyers")}
            >
              BUYERS {activeLink === "buyers" && <MdArrowOutward />}
            </a>
            <a
              href="#"
              className={`join-us-link font-merriweather ${activeLink === "sellers" ? "active" : ""}`}
              onClick={(e) => handleLinkClick(e, "sellers")}
            >
              SELLERS {activeLink === "sellers" && <MdArrowOutward />}
            </a>
          </motion.div>

          <motion.div className="right-section" variants={sectionVariant}>
            <AnimatePresence mode="wait">
              <motion.div
                key={activeLink}
                className="image-section"
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={contentVariant}
              >
                <img src={getImage()} alt="Stelmart" />
              </motion.div>
            </AnimatePresence>

            <AnimatePresence mode="wait">
              <motion.div
                key={activeLink}
                className="content-section"
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={contentVariant}
              >
                <h3 className="font-merriweather">{getContent().title}</h3>
                {getContent().description}
              </motion.div>
            </AnimatePresence>
          </motion.div>

        </motion.div>
      </div>

      <div className="stats-section custom-container-upper">
        <div className="">
          <div className="stats-image-container">
            <img src={Stats} alt="Stats Stelmart" className="stats-background-img" />
            <div className="overlays"></div>
          </div>
          <div className="stats-grid custom-container-side">
            <div className="stat-item font-kanit">
              <h2>{buyers}</h2>
              <p>Verified Buyers</p>
            </div>
            <div className="stat-item font-kanit">
              <h2>
                <span className="stat-number">{sellers}</span><span className="stat-plus">+</span>
              </h2>
              <p>Verified Sellers</p>
            </div>

            <div className="stat-item font-kanit">
              <h2>
                <span className="stat-number">{enquiries}</span><span className="stat-plus">+</span>
              </h2>
              <p>Enquiries Received</p>
            </div>
            <div className="stat-item font-kanit">
              <h2>
                <span className="stat-number">{quotations}</span><span className="stat-plus">+</span>
              </h2>
              <p>Quotations Submitted</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinUs;